import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { formatApiError, useAuth } from "../../lib/auth";
import { LogoMark } from "../../components/Logo";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="min-h-screen grid place-items-center px-5 pt-24 pb-16" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md border-2 border-ink bg-paper p-8 sm:p-10">
        <LogoMark className="h-12 w-12" />
        <h1 className="display text-5xl mt-6">Newsroom</h1>
        <p className="font-serif italic text-lg text-ink/70 mt-1">Editors only. Sign in to publish.</p>
        <label className="kicker block mt-8" htmlFor="admin-email">Email</label>
        <input id="admin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="admin-input mt-2" data-testid="admin-login-email" />
        <label className="kicker block mt-5" htmlFor="admin-password">Password</label>
        <input id="admin-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="admin-input mt-2" data-testid="admin-login-password" />
        {error && <p className="mt-4 text-sm text-rose" data-testid="admin-login-error">{error}</p>}
        <button disabled={busy} className="mt-8 w-full bg-ink text-cream kicker py-4 border-2 border-ink hover:bg-hot hover:text-ink transition-colors disabled:opacity-60" data-testid="admin-login-submit">
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </main>
  );
}
